import { SYSTEM_INPUT } from './topics';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { forConsole } from '../channels';

export const RELOAD = 'SYSTEM/RELOAD' as const;

export interface IReloadAction {
  type: typeof RELOAD;
  payload: {
    consoleId: string;
    timestamp: number;
  };
}

export const reloadActionSchema = objectSchemaOf<IReloadAction>({
  type: Joi.string().valid(RELOAD).required(),
  payload: objectSchemaOf<IReloadAction['payload']>({
    consoleId: Joi.string().required(),
    timestamp: Joi.number().required(),
  }),
});

export const reload = actionCreator({
  type: RELOAD,
  topic: SYSTEM_INPUT,
  schema: reloadActionSchema,
  channels: [forConsole],
});
